export class TokenExpander {
  constructor(replacements = {}) {
    this.replacements = replacements
  }

  expand(text) {
    return Object.entries(this.replacements).reduce((value, [token, replacement]) => {
      const safeReplacement = replacement == null ? "" : replacement.toString()
      return value.replaceAll(token, safeReplacement)
    }, (text || "").toString())
  }
}
